import { Helmet } from 'react-helmet';
import {
  Box,
  Card,
  CardContent,
  Alert,
  Button,
  Container,
  LinearProgress,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  FormControl,
  Typography,
  Select,
  InputLabel,
  MenuItem,
  TextField,
} from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { RacklistData } from 'src/components/rackrows/RackListData';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import moment from 'moment';
import Moment from 'react-moment';
import { checkAutoLogin } from 'src/actions/getTokenActions';

const RackList = () => {
  const [seldate, setdate] = useState(moment.utc().format());
  //const [seldate, setdate] = useState(moment('2023-06-06').utc().format());
  const [datacenterlist, setdatacenterlist] = useState([]);
  const [hourselect, sethourselect] = useState(moment().hours()); /// time now
  const isLogin = useSelector(state => state.gettocken.islogin);
  const [rawdata, setRawData] = useState([]);
  const [racksArray, setRacksArray] = useState([]);
  const [arrayToShow, setArrayToShow] = useState([]);
  const [rackNameList, setRackNameList] = useState("Alle");
  const [httpError, setHttpError] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch()
  const myRef = useRef(null)
  const [progress, setprogress] = useState(false);
  const [datacenterselect, setdatacenterselect] = useState("");
  let checkdata = []

  useEffect(() => {
    setprogress(true)
    const apiurl = sessionStorage.getItem('apiurl')
    let token = checkAutoLogin(dispatch)
    if (!token && isLogin === false) {
      navigate('/login', { replace: true });
    } else {
      axios.get(`https://${apiurl}/api/DataCenter`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        }
      }).then(res => {

        setdatacenterlist(res.data)
        if(datacenterselect === ""){
          res.data[0] && setdatacenterselect(res.data[0].name)
        }
        
      }).then(r =>
        axios.get(`https://${apiurl}/api/analytics/byrack?pointInTime=${seldate}`, {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token,
          }
        }).then(res => {
          //console.log('Data: ', res.data)
          setRawData(res.data)
        console.log("USEEFFECT: ",  res.data)
          if(res.data.datacenters !== undefined && res.data.datacenters.length > 0 ) {
            let dcName = ""
            datacenterselect === "" ? dcName = res.data.datacenters[0].datacenterName : dcName = datacenterselect
            let filterdatacenter  = res.data.datacenters.find((item) => item.datacenterName === dcName)
            console.log(filterdatacenter)
            setArrayToShow(filterdatacenter.rackRows)
            setRacksArray(filterdatacenter.rackRows)
          }
          setprogress(false)
        }).catch(function (error) {
          setHttpError(true)
          setprogress(false)
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message);
          }
          console.log(error.config);
        }
        )
      )
    }
  }, [seldate, isLogin])

  const handleChangeFrom = (newValue) => {
    console.log("seidate: ", seldate)
    setdate(newValue.utc().format());
    console.log("handleChangeFrom: ", newValue.utc().format())
  };

  const handleHourSelect = (hourValue) => {
    sethourselect(hourValue.target.value)
    let newdate = moment(seldate)
    newdate.set({ h: hourValue.target.value, m: 0, s: 0 })
    setdate(newdate.utc().format());
    console.log("handleHourSelect:  HOUR", hourValue.target.value)
    console.log("handleHourSelect: ", newdate.utc().format())
    setRackNameList("Alle")
  }

  const handlesetdatacenter = (Datacenter) => {
    setdatacenterselect(Datacenter.target.value)
    let filterdatacenter  = rawdata.datacenters.find((item) => item.datacenterName === Datacenter.target.value)
    if (filterdatacenter !== undefined) {
      setArrayToShow(filterdatacenter.rackRows)
      setRacksArray(filterdatacenter.rackRows)
    }
    setRackNameList("Alle")
  }

  if (rawdata.datacenters !== undefined) {
    checkdata = rawdata.datacenters
  }
  // Filter Funktionen
  console.log(rawdata)

  let from = moment(rawdata.measureFrom)
  let to = moment(rawdata.measureTo)

  const handleRackNameValue = (event) => {
    let value = event.target.value
    setRackNameList(value)
    let filterdatacenter = rawdata.datacenters.find((item) => item.datacenterName === datacenterselect)

    if (value === "Alle") {
      setArrayToShow(filterdatacenter.rackRows)
    } else {
      let newArrToShow = filterdatacenter.rackRows.filter(r => r.rackRowName === value)
      setArrayToShow(newArrToShow)
    }
  }
 
 
  return (
    <>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Helmet>
          <title>Racks</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 3
          }}
        >
          <Container maxWidth={false} >
            <Card>
              <CardContent>
                <Grid container spacing={2}>
                  <Grid item xs={3} md={3}>
                    <DateTimePicker
                      label="Datum am"
                      inputFormat="DD.MM.YYYY"
                      views={['day']}
                      value={seldate}
                      onChange={(e) => {
                        handleChangeFrom(e)
                       setRackNameList("Alle")
                      } }
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </Grid>
                  <Grid item xs={2} md={2}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-autowidth-label">Uhrzeit</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="hourselect"
                        label="Datacenter"
                        value={hourselect}
                        onChange={handleHourSelect}
                      >
                        <MenuItem value="">Uhrzeit</MenuItem>
                        <MenuItem value="1">01:00</MenuItem>
                        <MenuItem value="2">02:00</MenuItem>
                        <MenuItem value="3">03:00</MenuItem>
                        <MenuItem value="4">04:00</MenuItem>
                        <MenuItem value="5">05:00</MenuItem>
                        <MenuItem value="6">06:00</MenuItem>
                        <MenuItem value="7">07:00</MenuItem>
                        <MenuItem value="8">08:00</MenuItem>
                        <MenuItem value="9">09:00</MenuItem>
                        <MenuItem value="10">10:00</MenuItem>
                        <MenuItem value="11">11:00</MenuItem>
                        <MenuItem value="12">12:00</MenuItem>
                        <MenuItem value="13">13:00</MenuItem>
                        <MenuItem value="14">14:00</MenuItem>
                        <MenuItem value="15">15:00</MenuItem>
                        <MenuItem value="16">16:00</MenuItem>
                        <MenuItem value="17">17:00</MenuItem>
                        <MenuItem value="18">18:00</MenuItem>
                        <MenuItem value="19">19:00</MenuItem>
                        <MenuItem value="20">20:00</MenuItem>
                        <MenuItem value="21">21:00</MenuItem>
                        <MenuItem value="22">22:00</MenuItem>
                        <MenuItem value="23">23:00</MenuItem>

                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={4} md={4}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-autowidth-label">Datencenter</InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Datacenter"
                        value={datacenterselect}
                        onChange={handlesetdatacenter}
                      >
                        <MenuItem value="">Bitte wählen Sie ein Datencenter aus</MenuItem>
                        {datacenterlist.map((items) => {
                          return (
                            <MenuItem key={items.name} value={items.name}>{items.name}</MenuItem>
                          )
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {progress &&
              <LinearProgress />
            }
            <Box sx={{ pt: 3 }}>
              <Card>
                <CardContent>
                  <Grid container>
                    <Grid item xs={4} md={4}>
                      {datacenterselect !== "" &&
                        <Typography variant="h4">
                          Datencenter: {datacenterselect}
                        </Typography>
                      }
                      {datacenterselect === "" &&
                        <Typography variant="h4" sx={{ color: 'error.main' }}>
                          Datencenter: Bitte wählen Sie ein Datencenter aus!
                        </Typography>
                      }
                    </Grid>
                    <Grid item xs={3} md={3}><Typography variant="h4">Datum: <Moment format="DD.MM.YYYY">{seldate}</Moment></Typography></Grid>
                    <Grid item xs={4} md={4}><Typography variant="h4">Zeitraum: <Moment format="HH:mm">{from}</Moment> - <Moment format="HH:mm">{to}</Moment> Uhr</Typography></Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>

            <Box sx={{ pt: 3 }}>
              <Card >
                <CardContent>
                  <Box sx={{ minWidth: 1020 }}>
                    <Table stickyHeader>
                      <TableHead ref={myRef} >
                        <TableRow>
                          <TableCell>
                          <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
            <InputLabel id="rackV">Rack</InputLabel>
                          <Select
                        labelId="rackV"
                        id="rackV"
                        label="Rack"
                        value={rackNameList}
                        onChange={handleRackNameValue}
                      >
                           <MenuItem value="Alle"><em>Alle</em></MenuItem>
                          {racksArray.map((items) => {
                          return (
                            <MenuItem key={items.rackRowName} value={items.rackRowName}>{items.rackRowName}</MenuItem>
                          )
                        })}
                      </Select>
                      </FormControl>
                          </TableCell>
                          <TableCell>
                            Stromkreise
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {checkdata.length === 0 &&
                          <TableRow >
                            <TableCell colSpan="2">
                              {!httpError && <Alert severity="info">Für die Ausgewählten Einstellungen sind keine Daten verfügbar </Alert>}
                              {httpError && <Alert severity="error">Es ist ein Fehler aufgetreten! Bitte versuchen Sie es noch mal. </Alert>}
                            </TableCell>
                          </TableRow>
                        }

                        {checkdata.length !== 0 && datacenterselect !== "" &&
                          <RacklistData rawdata={arrayToShow} />
                        }

                      </TableBody>
                    </Table>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Container>
        </Box>
      </LocalizationProvider>
    </>
  );
};

export default RackList;
